import { module } from 'modujs';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m)
        this.$container       = this.el;
        this.apiKey           = this.getData('key');
        this.assetsVersion    = this.getData('assets-version');
        this.googleMapLoaded  = false;
        this.gmapScriptLoaded = false;
        this.mapStyles        = undefined;
    }

    /**
     * Displays the map after completing the download of all necessary styles and scripts
     */
    displayMap() {
        if (!this.gmapScriptLoaded || !this.googleMapLoaded || !this.mapStyles) {
            return;
        }

        const opts = {
            options: {
                center: {
                    // Arbitrary value decided with the initial fit_bounds on a given screen resolution
                    lat: 50.4820993,
                    lng: -72.7419642,
                },
                zoom:             13,
                minZoom:          4,
                mapType:          'roadmap',
                coordsType:       'inpage', // array, json? (vs ul li)
                map_mode:         'default',
                disableDefaultUI: true,
            },
            onfocus: (e, ctrl) => {
                this.call('activateTileFromId', e.data('ident'), 'MapList');
            },
            onblur: (e, ctrl) => {
                this.call('unactiveTile', e.data('ident'), 'MapList');
            },
            max_fitbounds_zoom: 10
        };

        this.mapController = new BB.gmap.controller(this.$container, opts);
        this.mapController.init();
        this.mapController.set_styles(this.mapStyles);

        this.mapController.ready(() => {
            this.mapController.fit_bounds();
        });

        this.fetchPlaces();
        // window.mapController = this.mapController;
    }

    /**
     * Fetch places to add on map
     */
    fetchPlaces() {
        fetch(`api/content/projects/map${html.lang ? `?lang=${html.lang}` : ''}`)
            .then((response) => {
                return response.text();
            })
            .then((response) => {
                const data   = JSON.parse(response);
                const places = data.feedback;

                // Add onclick callback to load project details
                for (const ident in places) {
                    places[ident].onclick = (_event, marker) => {
                        this.call('goTo', {
                            url: marker.data('url'),
                            transition: 'projectDetails',
                        }, 'Load')
                        this.call('target', ident, 'MapList')
                    }
                }
                this.addPlaces(data.feedback);
            });
    }

    /**
     * Add actual places to map
     *
     * @param places
     */
    addPlaces(places) {
        this.mapController.add_places(places);
        this.mapController.fit_bounds();
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        window._tmp_google_onload = () => {
            this.googleMapLoaded = true;
            this.displayMap();
        };

        if (typeof google === 'undefined') {
            // Can't assume google map is loaded after the script is added to the page
            this.getScript(
                'https://maps.googleapis.com/maps/api/js?v=3' +
                '&language=en&callback=_tmp_google_onload&key='+this.apiKey,
                function () {
                }
            );
        } else {
            this.googleMapLoaded = true;
        }

        if (typeof BB === 'undefined') {
            const jsAsset = 'assets/scripts/gmap.js?v=' + this.assetsVersion
            this.getScript(jsAsset, () => {
                this.gmapScriptLoaded = true;
                this.displayMap();
            });
        } else {
            this.gmapScriptLoaded = true;
        }

        fetch('assets/map/styles.json')
            .then((response) => {
                return response.text();
            })
            .then((response) => {
                let data       = JSON.parse(response);
                this.mapStyles = data;
                this.displayMap();
            });
    }

    activeMarker(id) {
        this.mapController.get_place(id).focus();
        this.mapController._loop_all((p) => {
            if (p.data('ident') == id) {
                p.show();
            } else {
                //p.hide();
            }
        })
        // Commented out as this could feel weird
        // this.zoomOn(id);
    }

    unactiveMarker() {
        this.mapController.remove_focus();
        this.mapController._loop_all((p) => {
            p.show();
        })
        this.mapController.fit_bounds();
    }

    zoomOn(id) {

        // Scope
        var bounds = new google.maps.LatLngBounds();

        var k = 0;
        this.mapController._loop_all((obj) => {
            if (obj.data('ident') != id) {
                return false;
            }
            var paths = obj.get_position();
            if (!paths) {
                return false;
            }
            var path;

            // Worst fix ever.
            if (paths instanceof google.maps.LatLng) {
                bounds.extend(paths);
            } else {
                for (var i = 0; i < paths.getLength(); i++) {
                    path = paths.getAt(i);
                    for (var ii = 0; ii < path.getLength(); ii++) {
                        bounds.extend(path.getAt(ii));
                    }
                }
            }
            k++;
        });

        if (k > 0) {
            this.mapController.map().fitBounds(bounds);
            this.mapController.map().setZoom(11);
        }

    }

    destroy() {
        super.destroy()
    }

    /**
     * Vanilla getScript function
     *
     * @param src
     * @param cb
     */
    getScript(src, cb) {
        let script = document.createElement('script');
        let prior  = document.getElementsByTagName('script')[0];
        // script.async = 1;

        script.onload = script.onreadystatechange = function (_, isAbort) {
            if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
                script.onload = script.onreadystatechange = null;
                script        = undefined;
                if (!isAbort && cb) setTimeout(cb, 0);
            }
        };

        script.src = src;
        prior.parentNode.insertBefore(script, prior);
    }
}
